var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { SpaceLabelsRepository } from './space-labels-repository.interface';
import { SpaceLabelsModel } from '../model/space-labels-model.interface';
let SpaceLabelsServiceImpl = class SpaceLabelsServiceImpl {
    constructor(_spaceLabelsRepository, _spaceLabelsModel) {
        this._spaceLabelsRepository = _spaceLabelsRepository;
        this._spaceLabelsModel = _spaceLabelsModel;
    }
    async querySpaceLabels() {
        const data = await this._spaceLabelsRepository.querySpaceLabels();
        this._spaceLabelsModel.update(() => data);
        return data;
    }
};
SpaceLabelsServiceImpl = __decorate([
    injectable(),
    __param(0, inject(SpaceLabelsRepository)),
    __param(1, inject(SpaceLabelsModel)),
    __metadata("design:paramtypes", [typeof (_a = typeof SpaceLabelsRepository !== "undefined" && SpaceLabelsRepository) === "function" ? _a : Object, typeof (_b = typeof SpaceLabelsModel !== "undefined" && SpaceLabelsModel) === "function" ? _b : Object])
], SpaceLabelsServiceImpl);
export { SpaceLabelsServiceImpl };
